import ValidationSuccess from './ValidationSuccess';
import ValidationFail from './ValidationFail';
import {
  getVideoResolutionTooSmallMessage,
  getVideoTooLargeMessage,
  getVideoTooShortMessage,
  getVideoTooLongMessage,
  getVideoTooWideMessage,
  getVideoFrameRateMessage,
} from './utils/validationErrorMessages';
import ValidationResult from './ValidationResult';

export function validateVideo(video, serviceDefinition): ValidationResult {
  if (video === null) {
    return new ValidationSuccess();
  }

  if (
    serviceDefinition.videoMinResolution &&
    (video.height < serviceDefinition.videoMinResolution ||
      video.width < serviceDefinition.videoMinResolution)
  ) {
    return new ValidationFail(
      getVideoResolutionTooSmallMessage(serviceDefinition.videoMinResolution)
    );
  }

  if (
    serviceDefinition.videoMaxSize &&
    video.size > serviceDefinition.videoMaxSize
  ) {
    const maxFileSizeInMb = serviceDefinition.videoMaxSize / 1024 / 1024;

    return new ValidationFail(getVideoTooLargeMessage(maxFileSizeInMb));
  }

  if (
    serviceDefinition.videoMinDurationMs &&
    video.durationMs < serviceDefinition.videoMinDurationMs
  ) {
    return new ValidationFail(
      getVideoTooShortMessage(serviceDefinition.videoMinDurationMs / 1000)
    );
  }

  if (
    serviceDefinition.videoMaxDurationMs &&
    video.durationMs > serviceDefinition.videoMaxDurationMs
  ) {
    return new ValidationFail(
      getVideoTooLongMessage(serviceDefinition.videoMaxDurationMs / 1000)
    );
  }

  if (
    serviceDefinition.videoMaxWidth &&
    video.width > serviceDefinition.videoMaxWidth
  ) {
    return new ValidationFail(
      getVideoTooWideMessage(serviceDefinition.videoMaxWidth, video.width)
    );
  }

  if (
    serviceDefinition.videoMinFrameRate &&
    serviceDefinition.videoMaxFrameRate &&
    video.frameRate &&
    (video.frameRate < serviceDefinition.videoMinFrameRate ||
      video.frameRate > serviceDefinition.videoMaxFrameRate)
  ) {
    return new ValidationFail(
      getVideoFrameRateMessage(
        serviceDefinition.videoMinFrameRate,
        serviceDefinition.videoMaxFrameRate,
        video.frameRate
      )
    );
  }

  return new ValidationSuccess();
}
